<template>
  <div :class="$style['pt-lab-order-detail']" ref="table">
    <pt-page-title title="订单详情"></pt-page-title>
    <pt-sub-title title="订单状态">
      <span slot="line" style="color:red;margin-left:10px;" v-if="order && showWarning">{{warningInfo}}</span>
      <pt-legend :statusArray="statusArray"></pt-legend>
    </pt-sub-title>
    <!-- 步骤条 -->
    <pt-lab-order-progress :class="$style['order_progress']" :order-status="statuses" :task="task" :order-detail="order"
      :tasks="tasks"></pt-lab-order-progress>
    <!-- 状态操作需补充 -->
    <p v-if="isComplete" style="height:20px;"></p>
    <template v-else>
      <template v-if="order && HAS_PERM_LAB_OPERATION">
        <order-status :order-detail="order" :task="task" :status="nextStatus" :order="order"
          v-if="!this.$route.params.approval" @status-change="reload" :order-status="statuses" @isLoading="isLoading"
          :hideForm="this.orderflowHelper.canNotOperation(this.nextStatus,this.order)">
          <a style="margin-left:20px;" v-if="order.reportJobId && nextStatus==='REPORT_CHECKED_1ST'">
            <el-button @click="showReport=true" size="small" type="primary">查看在线报告</el-button>
          </a>
          <!-- <a style="margin-left:20px;" v-if="order.reportOssUrl && nextStatus==='REPORT_CHECKED_1ST'" :href="$privateResourcesUrl+order.reportOssUrl" target="_blank"><el-button size="small" type="primary">查看PDF报告</el-button></a> -->
        </order-status>
        <p v-else style="height:10px;"></p>
      </template>
    </template>
    <!-- <el-button @click="showReport=true" size="small" type="primary">查看报告</el-button> -->
    <!-- 样本信息 -->
    <pt-sub-title title="样本及用户信息"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['order-info']">
        <span>样本条码号：{{order.sampleId ? order.sampleId : '--'}}</span>
        <span v-if="order.labCode">生产条码号：{{order.labCode ? order.labCode : '--'}}</span>
        <span>样本类型：{{order.currentSample ? getEnumeration(order.currentSample.sampleType,sampleType) : '--'}}</span>
        <span>采集日期：{{order.currentSample.collectTime ? formatDate(order.currentSample.collectTime) :'--'}}</span>
        <span>接收日期：{{order.otherInfo.SampleReceiveTime ? formatDate(order.otherInfo.SampleReceiveTime) :'--'}}</span>
        <span
          v-if="order.samplesSentToCheckDate">运输日期：{{order.samplesSentToCheckDate ? formatDate(order.samplesSentToCheckDate) :'--'}}</span>
        <span v-if="order.collectTimes!==null">采集次数：第{{order.collectTimes}}次</span>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <template v-if="order.patient">
          <span>报告接收人：{{order.patient.reportReceiverName ? order.patient.reportReceiverName :'--'}}</span>
          <span>报告接收人联系方式：{{order.patient.reportReceiverMobile ? order.patient.reportReceiverMobile :'--'}}</span>
          <span>报告邮寄地址：{{order.patient ? (order.patient.reportReceivingProvince||'')+ (order.patient.reportReceivingCity||'') +(order.patient.reportReceivingDistrict||'')+(order.patient.reportReceivingAddress||'') :'--'}}</span>
          <span>报告接收邮箱：{{order.patient.reportReceiverMail ? order.patient.reportReceiverMail :'--'}}</span>
        </template>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <template v-if="order.otherInfo">
          <span v-if="order.otherInfo.contractNumber">合同书号：{{order.otherInfo.contractNumber}}</span>
          <span v-if="order.otherInfo.proposerName">申请人姓名（母亲）：{{order.otherInfo.proposerName}}</span>
          <span v-if="order.otherInfo.mallOrderPlacerIDCard">申请人身份证号：{{order.otherInfo.mallOrderPlacerIDCard}}</span>
          <span v-if="order.otherInfo.patientNewBorn !==null">是否新生儿：{{order.otherInfo.patientNewBorn? '是': '否'}}</span>
          <span
            v-if="order.otherInfo.hasUCBContract !==null">是否有存储类合同：{{order.otherInfo.hasUCBContract ? '是': '否'}}</span>
        </template>
      </wt-box>
    </wt-grid>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['order-info']">
        <template v-if="order.patient">
          <span>受检人：{{order.patient.name ? order.patient.name :'--'}}</span>
          <span>性别：{{order.patient.gender ? genderFormat(order.patient.gender) : '--'}}</span>
          <span>年龄：{{order.patient.age === 0 ? 0 : (order.patient.birthday || order.patient.age ?  order.patient.age || birthdayToAge(order.patient.birthday):'--')}}</span>
          <span>出生日期：{{order.patient.birthday ? formatDate(order.patient.birthday) :'--'}}</span>
          <span>手机号：{{order.patient.mobile ? order.patient.mobile :'--'}}</span>
          <span>{{certificatesTypeMap[order.patient.identityCardType] || '证件'}}号：{{order.patient.identityCard ? order.patient.identityCard :'--'}}</span>
          <span v-if="order.patient.nation">民族：{{order.patient.nation}}</span>
          <span v-if="order.otherInfo.businessOriginArea">地区：{{order.otherInfo.businessOriginArea}}</span>
          <span v-if="order.patient.address">客户地址：{{order.patient.address}}</span>
        </template>
        <template v-if="order.otherInfo">
          <p></p>
          <span>C端用户：<span
              :class="$style['specialColor']">{{order.otherInfo.mallOrderPlacerNickName ? order.otherInfo.mallOrderPlacerNickName :'--'}}</span></span>
          <span>手机号：{{order.otherInfo.mallOrderPlacerPhone ? order.otherInfo.mallOrderPlacerPhone :'--'}}</span>
          <span v-if="order.orderStatusEnum === 'COMPLETED'">
            <template v-if="hasSample">
            <span v-if="reportVisable">C端报告：已对用户可见 <span :class="$style.aColor" @click="toOperation"> 隐藏</span></span>
            <span v-if="!reportVisable">C端报告：已对用户隐藏 <span :class="$style.aColor" @click="toOperation"> 展示</span></span>
            </template>
            <template v-else>
            <span>该实验室订单在C端暂无样本 </span>
            </template>
          </span>
        </template>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <span v-if="order.otherInfo.gestationalAge">孕周：{{order.otherInfo.gestationalAge}}</span>
        <span v-if="order.otherInfo.inspectionHospital">送检医院：{{order.otherInfo.inspectionHospital}}</span>
        <span v-if="order.otherInfo.inspectionDoctor">送检医生：{{order.otherInfo.inspectionDoctor}}</span>
      </wt-box>
    </wt-grid>
    <!-- 订单信息 -->
    <pt-sub-title title="订单信息"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['order-info']">
        <span style="white-space: nowrap;">订单号：{{order.id}}<pt-copy-button type="text" :copyContent="order.id"
            text="[复制]" :class="$style['order-message-id']"></pt-copy-button></span>
        <span>订单来源：{{order.salesFrom ? formatSaleFrom(order.salesFrom) : '--'}}</span>
        <span>订单类型：{{order.workflow==='REPORT_ONLY_UNLOCK' ? '解锁订单' : '购买订单'}}</span>
        <span>产品编号：{{order.agentProductCode ? order.agentProductCode : '--'}}</span>
        <span>检测套餐：{{order.detectionPackageNames ? order.detectionPackageNames.toString() : '--'}}</span>
        <span
          v-if="order.otherInfo && order.otherInfo.mallOrderName">订单内容：{{order.otherInfo.mallOrderName ? order.otherInfo.mallOrderName : '--'}}</span>
        <span>检测平台：{{order.product ? order.product.name : '--'}}</span>
        <span>报告分析计算：{{order.packageProductionType==='THIRDPARTY' ? '第三方出报告' : '中源协和计算'}}</span>
        <span>下单时间：{{formatDateObject(order.createdTime)}}</span>
        <span>代理商：{{order.clientOrganization.fullName ? order.clientOrganization.fullName : '--'}}</span>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <span>DNA提取人：{{order.otherInfo ? order.otherInfo.DNAExtractionOperator :'--'}}</span>
        <span>实验人员：{{order.otherInfo ? order.otherInfo.SequencingTestOperator :'--'}}</span>
        <span>数据分析与报告人员：{{order.otherInfo ? order.otherInfo.Checker1 :'--'}}</span>
      </wt-box>
    </wt-grid>
    <pt-sub-title title="计算结果及检测报告"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['order-info']">
        <span v-if="order.reportJobId">
          计算结果：{{`${order.patient.name}（${order.sampleId}）`}}
          <router-link :to="resultUrl" :class="$style.aColor">
            查看计算结果
          </router-link>
        </span>
        <span v-if="order.reportJobId">
          在线报告：{{`${order.patient.name}（${order.sampleId}）`}}
          <a @click="showReport=true" :class="$style.aColor">查看在线报告</a>
        </span>
        <span v-if="order.reportOssUrls">
          PDF报告：{{`${order.patient.name}（${order.sampleId}）`}}
          <p v-for="(file,i) in order.reportOssUrls" :key="i" style="margin-left:60px;">
            <template v-if="file">
              {{getFileName(file)}}
              <a :href="$previewResourceUrl+file.replace(/\+/g, '%2B')" target="_blank" :class="$style.aColor">
                查看报告
              </a><br>
            </template>
          </p>
        </span>
      </wt-box>
    </wt-grid>
    <!-- 附件信息 -->
    <template v-if="order && order.attachments">
      <pt-sub-title title="相关文件"></pt-sub-title>
      <wt-grid :col="1" grid-gap="10px" :class="$style['order-info__box']">
        <a :href="$privateResourcesUrl+file.ossUrl.replace(/\+/g, '%2B')" target="_blank"
          style="dispaly:block;color:#EDBE83;" v-for="(file,index) in order.attachments"
          :key="index">{{file.name || file.ossUrl}}</a>
      </wt-grid>
    </template>
    <!-- 操作记录：只记录特殊操作的 -->
    <pt-sub-title title="操作记录"></pt-sub-title>
    <wt-grid :col="1" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['special-operate']" v-for="(log,key) in logs" :key="key">
        <template v-if="log.orderStatusResult==='SAMPLE_RECOLLECT'">
          <span>{{formatDateObject(log.operationTime)}}</span>
          <span>
            创建第{{log.recollectTimes}}次重采订单
            <router-link v-if="order.sampleId !== log.newSampleId" :to="`/lab-order-detail/${log.newOrderId}`"
              :class="$style.maincolor">{{log.newSampleId}}</router-link>
            <span :class="$style.maincolor" v-else>{{log.newSampleId}}</span>
            原始样本条码号：
            <router-link v-if="order.sampleId !== log.sampleId" :to="`/lab-order-detail/${log.orderId}`"
              :class="$style.maincolor">{{log.sampleId}}</router-link>
            <span v-else :class="$style.maincolor">{{log.sampleId}}</span>
          </span>
        </template>
        <template v-else>
          <span>{{formatDateObject(log.operationTime)}}</span>
          <span>
            {{orderflowHelper.formatTargetOrderStatus(log.orderActions)}}
          </span>
          <span>{{log.auditInformation.operatorName + formatOperationLog(log.orderStatusResult)}}</span>
          <span v-if="log.reason">原因是：{{log.reason}}</span>
        </template>
      </wt-box>
    </wt-grid>
    <pt-sub-title title="历史检测"></pt-sub-title>
    <wt-grid :col="1" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['special-operate']" v-for="(item,i) in order.historyOrders" :key="i">
        <span>订单号：{{item.id}}</span>
        <span>商品名称：{{item.detectionPackageNames ? item.detectionPackageNames.toString() : '--'}}</span>
        <span>样本条码号：<router-link target="_blank" :to="{ path: `/lab-order-detail/${item.id}` }">
            <a style="color:#EDBE7C">{{item.sampleId}}</a>
          </router-link>
        </span>
      </wt-box>
    </wt-grid>
    <!-- <template v-if="order">
      <router-link :to="resultUrl" v-if="order.reportJobId">
        <el-button type="primary" size="small" style="margin-top:10px;">查看计算结果</el-button>
      </router-link>
      <a style="margin-left:20px;" v-if="order.reportJobId && isComplete">
        <el-button @click="showReport=true" size="small" type="primary">查看在线报告</el-button>
      </a>
      <a style="margin-left:20px;" v-if="order.reportOssUrl" :href="$privateResourcesUrl+order.reportOssUrl" target="_blank"><el-button size="small" type="primary">查看PDF报告</el-button></a>
    </template> -->
    <template v-if="order">
      <review-report-iframe :isDialog="showReport" :labCode="order.labCode" :sampleId="order.sampleId"
        :packageId="order.detectionPackageIds[0]" :jobId="order.reportJobId" :fullName="order.patient.name"
        @closeDialog="showReport=false"></review-report-iframe>
    </template>
    <el-button size="small" type="primary" v-if="HAS_PERM_LAB_EDIT_ORDER" @click="goEdit(order.id)">编辑订单信息</el-button>
    <el-button size="small" type="danger" v-if="HAS_PERM_LAB_DELETE_ORDER" @click="goDelete(order.id)">删除订单</el-button>
  </div>
</template>

<script>
// 组件class前缀
import ptLegend from 'cps/base/pt-legend'
import ptLabOrderProgress from './pt-lab-order-progress'

import {
  genderFormat,
  formatDate,
  formatDateObject,
  birthdayToAge
} from '@/utils/formUtils'
import orderflowHelper from '@/config/order'
import orderStatus from 'cps/lab-order/order-status'
import {
  formatOperationLog,
  formatSaleFrom
} from 'enumeration/lab-order.js'
import reviewReportIframe from 'cps/lab-order/order-status/form/components/review-report-iframe'
import {
  certificatesTypeMap
} from 'json/lab-order'
import {
  sampleType
} from 'json/goods-order-options'
import {
  getEnumeration
} from 'enumeration'
import {
  hasPermissions
} from 'utils/permissions'
import { getDayTypes } from 'enumeration/mall.js'
const prefixCls = 'pt-lab-order-detail'
const PERM_LAB_EDIT_ORDER = 'PERM_LAB_EDIT_ORDER'
// 实验室订单删除权限
const PERM_LAB_DELETE_ORDER = 'PERM_LAB_DELETE_ORDER'
// 实验室订单操作
const PERM_LAB_OPERATION = 'PERM_LAB_OPERATION'
// const PERM_STATUS_MAP = {
//   'LAB_SAMPLES_RECEIVED': 'PERM_LAB_SAMPLE_RECEIVE',
//   'LAB_DNA_READY': 'PERM_LAB_DNA_READY',
//   'DATA_ANALYSISED': 'PERM_LAB_DATA_ANALYSISED',
//   'REPORT_CHECKED_1ST': 'PERM_LAB_CHECKED_1ST'
// }
export default {
  name: 'pt-lab-order-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isComplete () {
      return this.order && this.order.nextOrderAction === 'NONE'
      // if (this.statuses[this.statuses.length - 1]) {
      //   return (
      //     false
      //   //   this.statuses[this.statuses.length - 1].orderStatus === 'COMPLETED'
      //   )
      // }
      // return false
    },
    nextStatus () {
      // let flowName = 'LAB'
      // return this.statuses && this.statuses.length
      //   ? orderflowHelper.getNextOrderStatus(
      //     flowName,
      //     this.statuses[this.statuses.length - 1].orderStatus,
      //     true
      //   )
      //   : ''
      return this.order.nextOrderAction
    },
    resultUrl () {
      return '/show-calculate-result/' + this.order.reportJobId
    },
    HAS_PERM_LAB_EDIT_ORDER () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions,
        PERM_LAB_EDIT_ORDER)
    },
    HAS_PERM_LAB_DELETE_ORDER () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions,
        PERM_LAB_DELETE_ORDER)
    },
    HAS_PERM_LAB_OPERATION () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions,
        PERM_LAB_OPERATION)
    },
    showWarning () {
      let status = orderflowHelper.formatOrderActions(this.order.nextOrderAction)
      return this.order.remainingDays !== null && this.order.remainingDays <= 3 && status !== '已完成' && this.order
        .orderStatusEnum !== 'CLOSED'
    },
    warningInfo () {
      return `预计交付日期${formatDate(this.order.expectedDeliveryDate)}，剩余${this.order.product.dayType ? getDayTypes(this.order.product.dayType) : ''}${this.order.remainingDays}`
    }
    // disabled () {
    //   return this.order && this.order.nextOrderAction !== 'LAB_SAMPLES_RECEIVED'
    // }
  },
  props: {
    statuses: {
      type: Array,
      default: () => []
    },
    task: {
      type: Object
    },
    order: {
      type: Object,
      default: () => {}
    },
    tasks: {
      type: Array,
      default: () => []
    },
    logs: {
      type: Array,
      default: () => []
    },
    sampleRecollectLogs: {
      type: Array,
      default: () => []
    },
    reportVisable: {
      type: Boolean,
      default: false
    },
    hasSample: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      certificatesTypeMap: certificatesTypeMap,
      sampleType: sampleType,
      showReport: false,
      orderflowHelper: orderflowHelper,
      statusArray: [{
        color: '#70ad47',
        text: '正常'
      },
      {
        color: '#f56c6c',
        text: '异常'
      },
      {
        color: '#f69b07',
        text: '待处理'
      }
      ]
    }
  },
  components: {
    ptLegend,
    ptLabOrderProgress,
    orderStatus,
    reviewReportIframe
  },
  methods: {
    genderFormat,
    formatDate,
    formatDateObject,
    formatOperationLog,
    getEnumeration,
    birthdayToAge,
    formatSaleFrom,
    reload () {
      this.$emit('on-reload')
      // this.load()
      // this.loadOrderStatus()
    },
    isLoading (val) {
      this.$emit('handle-loding', val)
      // this.loading = val
    },
    getFileName (fileUrl) {
      let arr = fileUrl.split('/')
      return arr[arr.length - 1]
    },
    goEdit (id) {
      this.$router.push(`/lab-order-form/true/${id}`)
    },
    toOperation () {
      this.$store.dispatch('toVisibleReport', this.order.id).then((response) => {
        this.$parent.getReportDetail()
        // this.$store.dispatch('ReportDetail', this.order.id).then((response) => {
        //   this.reportVisable = response.data.visible
        // })
        // this.getReportDetail()
      }).catch((error) => {
        console.error(error)
      })
    },
    goDelete (id) {
      this.$confirm('点击“确定”，将永久删除本订单并不能恢复，请谨慎操作。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('handle-loding', true)
        this.$store.dispatch('deleteLabOrder', id).then((response) => {
          this.$emit('handle-loding', false)
          this.reload()
          // this.$message.success('请在“异常订单”页面确认删除订单')
          // history.go(-1)
        }).catch((error) => {
          this.$emit('handle-loding', false)
          console.error(error)
          this.$message.error(error + '删除订单失败！')
        })
      })
    }
  }
}

</script>

<style module lang="less">
  @import '~less/var.less';

  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .order-message-id {
    padding: 0 0 0 10px;

    span {
      color: #edbe81 !important
    }
  }

  .pt-lab-order-detail {
    :global .el-radio {
      &+.el-radio {
        margin-left: 30px;
      }
    }
  }

  .order-info__box {
    padding: 10px 20px;
  }

  .order-info {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    span {
      font-size: 14px;
      color: #666;
      line-height: 30px;
    }
  }

  .order_progress {
    margin-top: 30px;
  }

  .special-operate {
    display: block;

    span {
      margin-right: 30px;
      color: #666;
      line-height: 30px;
    }
  }

  .maincolor {
    color: @mainColor  !important;
    display: inline-block;
    margin: 0 10px !important;
  }

  .specialColor {
    color: @mainColor  !important;
  }

  .aColor {
    color: @mainColor  !important;
    margin-left: 10px;
    text-decoration: none;
  }

</style>
